/** @import modules */

import { useTranslation }       from "react-i18next";

/**
 *
 * @param { legalData }
 *
 * @returns Requisites compontent for contacts page
 *
 */

const Requisites = ( { legalData } ) => { const

    { t } = useTranslation (),

    List = [

        { name: t ( "company_name" ),               value: legalData?.legalEntityName,      marked: false   },

        { name: t ( "reg_no" ),                     value: legalData?.registrationNumber,   marked: true    },

        { name: t ( "legal_address" ),              value: legalData?.legalAddress,         marked: true    },

        { name: t ( "factual_address" ),            value: legalData?.factualAddress,       marked: true    }

    ],

    enabledBanks = legalData?.bankAccounts?.filter ( acc => acc.isEnabled ) || [],

    /** Show default bank if set, otherwise first enabled */
    displayBank = enabledBanks.find ( acc => acc.isDefault ) || enabledBanks[ 0 ],

    Collection = ( { param } ) => <ul>
        
        { param.map ( ( req, index ) => <li key={ index }>

            { ( req.marked ) ? `${ req.name }: ${ req.value }` : `${ req.value }` }

        </li> ) }
        
    </ul>;

    /** @return component */

    return ( <div className="requisites">

        <div className="headline">

            { t ( "requisites" ) }

        </div>

        <div className="list">

            <Collection param={ List } />

            { displayBank && <ul style={ { marginTop: "0.5rem" } }>

                <li>{ t ( "bank_type" ) }: { displayBank.bankName }</li>

                <li>{ t ( "bank_account_number" ) }: { displayBank.iban }</li>

                { displayBank.swiftCode && <li>{ t ( "swift" ) }: { displayBank.swiftCode }</li> }

            </ul> }

        </div>

    </div> );

}
 
/** @export Requisites */

export default Requisites;